import React from 'react';
import { Award, Footprints, TriangleAlert, Moon, Flame, Zap, Trophy, Bookmark } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// --- ICON MAPPER FOR BADGES ---
export const BadgeIcon: React.FC<{ iconName: string; size?: number; className?: string }> = ({
  iconName,
  size = 24,
  className,
}) => {
  const icons: Record<string, React.ElementType> = {
    Footprints: Footprints,
    TriangleAlert: TriangleAlert,
    Moon: Moon,
    Flame: Flame,
    Zap: Zap,
    Trophy: Trophy,
    Bookmark: Bookmark,
  };
  const Icon = icons[iconName] || Award;
  return <Icon size={size} className={className} />;
};

export const BadgeModal: React.FC<{ isOpen: boolean; badge: any; onClose: () => void }> = ({
  isOpen,
  badge,
  onClose,
}) => {
  const { t } = useTranslation();
  if (!isOpen || !badge) return null;
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/40 backdrop-blur-md animate-in zoom-in-95 duration-300"
      role="dialog"
      aria-modal="true"
      aria-labelledby="badge-modal-title"
    >
      <div className="glass-strong rounded-3xl p-8 max-w-sm w-full text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/20 to-transparent pointer-events-none"></div>

        <div className="mx-auto w-24 h-24 bg-gradient-to-br from-yellow-300 to-orange-500 rounded-full flex items-center justify-center mb-6 shadow-lg shadow-orange-500/40 animate-bounce">
          <BadgeIcon iconName={badge.icon} size={48} className="text-white drop-shadow-md" />
        </div>

        <div className="text-primary font-bold tracking-widest text-xs uppercase mb-2">
          {t('achievement_unlocked')}
        </div>
        <h2 id="badge-modal-title" className="text-3xl font-black text-white mb-2">
          {t(badge.nameKey)}
        </h2>
        <p className="text-gray-400 mb-8 leading-relaxed">{t(badge.descKey)}</p>

        <button
          onClick={onClose}
          className="w-full py-3 px-6 rounded-xl font-bold bg-white text-gray-900 hover:bg-gray-100 transition-all active:scale-95"
        >
          {t('awesome')}
        </button>
      </div>
    </div>
  );
};
